import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ExtensionIcon from '@mui/icons-material/Extension';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import StarBorderPurple500Icon from '@mui/icons-material/StarBorderPurple500';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import project from '../assets/projects.webp';
const Why = () => {
  return (
    <Box backgroundColor="rgb(244, 244, 244)">
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 3 },
        mx: 'auto',
        py: 8,
        fontFamily: 'Nunito, sans-serif',
        width: {
          xs: '95%',
          sm: '100%',
          md: '100%',
          lg: '85%',
          xl: '85%',
        },
      }}
      maxWidth="lg"
    >
      <Box
        component="img"
        src={project}
        alt="About"
        sx={{
          width: '50%',
          height: '80%',
          borderRadius: 2,
          // display: { xs: 'block', md: 'block' },
          mr: { md: 8 },
        }}
      />

      {/* Right Content */}
      <Box sx={{ width: { xs: '100%', md: '50%' }, mt: { xs: 4, md: 0 } }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Rajdhani',
            fontWeight: 600,
            fontSize: '19px',
            color: '#0c5adb',
          }}
        >
          OUR WORK
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Rajdhani',
            color: '#232323',
            fontWeight: 'bold',
            lineHeight: 1.2,
          }}
        >
          What Makes Our Projects

          <br /> <span style={{ color: '#075AD6' }}>Stand Out</span>
        </Typography>

        <Typography fontSize={'13px'} color="#686868" fontFamily={'Nunito'} my={'20px'}>
          We take pride in building digital products that are not just visually appealing,
          but also performance-driven and user-focused. From idea to execution, our work
          reflects precision, creativity, and real-world impact.
        </Typography>

        {/* Q&A Section */}
        <Box sx={{ mt: 2, color: '#000000ff', fontFamily: 'Nunito' }}>
          {[
            {
              icon: (
                <ExtensionIcon
                  sx={{
                    color: '#1976d2',
                    fontSize: 40,
                    mt: 2,
                    mr: 2,
                  }}
                />
              ),
              question: 'Tailored Solutions',
              answer:
                'Every project is customized to meet the unique needs and goals of each client..',
            },
            {
              icon: (
                <ColorLensIcon
                  sx={{
                    color: '#1976d2',
                    fontSize: 40,
                    mt: 2,
                    mr: 2,
                  }}
                />
              ),
              question: 'Modern UI/UX Design',
              answer:
                'We prioritize clean, intuitive, and mobile-friendly interfaces for seamless user experiences.',
            },
            {
              icon: (
                <StarBorderPurple500Icon
                  sx={{
                    color: '#1976d2',
                    fontSize: 40,
                    mt: 2,
                    mr: 2,
                  }}
                />
              ),
              question: 'Industry Versatility',
              answer:
                'Our portfolio spans startups, enterprises, and diverse industries—from tech to retail.',
            },
            {
              icon: (
                <RocketLaunchIcon
                  sx={{
                    color: '#1976d2',
                    fontSize: 40,
                    mt: 2,
                    mr: 2,
                  }}
                />
              ),
              question: 'Performance-Focused Development',
              answer:
                'Optimized code and smart architecture ensure speed, scalability, and security..',
            },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}
            >
              {item.icon}
              <Box>
                <Typography variant="subtitle1" fontFamily={'Rajdhani'} fontWeight="bold">
                  {item.question}
                </Typography>
                <Typography variant="body2" fontFamily={'nunito'} fontWeight={500}>
                  {item.answer}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Button */}
        <Button
          sx={{
            mt: '50px',
            position: 'relative',
            overflow: 'hidden',
            borderRadius: '3px',
            px: '10px',
                        py: '3px',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontFamily: 'Rajdhani',
            fontSize: '17px',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            backgroundColor: '#0c5ADB',
            color: '#fff',
            border: '2px solid #0c5ADB',
            width: 'fit-content', // 👈 Added line
            transition:
              'color 0.4s ease-in-out, background-color 0.4s ease-in-out',

            '& span, & .arrow-circle': {
              position: 'relative',
              zIndex: 1,
            },

            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              backgroundColor: '#fff',
              zIndex: 0,
              transform: 'translateX(100%)',
              transition: 'transform 0.4s ease-in-out',
            },

            '&:hover::before': {
              transform: 'translateX(0%)',
            },

            '&:not(:hover)::before': {
              transform: 'translateX(-100%)',
            },

            '& .arrow-circle': {
              backgroundColor: '#fff',
              color: '#075AD6',
              borderRadius: '50%',
              padding: '3px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.4s ease-in-out',
            },

            '&:hover': {
              color: '#075AD6',
              '& .arrow-circle': {
                backgroundColor: '#0c5ADB',
                color: '#fff',
              },
            },
          }}
          component={Link}
          to="/projects"
        >
          <span>OUR PORTFOLIO</span>
          <span className="arrow-circle">
            <ArrowForwardIcon fontSize="small" />
          </span>
        </Button>

      </Box>
    </Box>
    // </Box>
  );
};

export default Why;
